import { render, staticRenderFns } from "./LotDisplay.vue?vue&type=template&id=362a955a&scoped=true&"
import script from "./LotDisplay.vue?vue&type=script&lang=js&"
export * from "./LotDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LotDisplay.vue?vue&type=style&index=0&id=362a955a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362a955a",
  null
  
)

export default component.exports